import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {PrimoResponse} from "../../infra/dataStructures/PrimoResponses/doc.interfcae";
import {CollectionDiscoveryService} from "../collectionDiscovery.service";
import {getInstitutionCode} from "../../appConfig/appConfigForward";
const get= require('lodash/get');

@Component({
    selector: 'prm-record-collection-paths',
    templateUrl: 'components/collectionDiscovery/recordCollectionPaths/record-collection-paths.html',
})

export class PrmRecordCollectionPaths implements OnInit{
    @Input() item: PrimoResponse.IDoc;
    @Input() almaDisplay: boolean;
    @Input() collectionPath: string;
    private paths: [Object];
    constructor(private collectionDiscoveryService: CollectionDiscoveryService,
                @Inject('$q') private $q: ng.IQService,
                @Inject('$mdDialog') private $mdDialog:angular.material.IDialogService ,) {
    }

    ngOnInit() {
    	if (this.almaDisplay) {
    			var inst = getInstitutionCode();
    			this.paths = [{institution: inst, path: []}];
    			if (this.collectionPath != undefined && this.collectionPath != null && this.collectionPath != "")  {
    				var colls = JSON.parse(this.collectionPath);
    				if (colls != undefined && colls.length > 0) {
		                this.paths= colls.map((coll, index)=>{
	    					var curCollPath = [];
	    					var j = 0;
	    					for (var j = 0; j < coll.length; j++) {
	    						curCollPath.push({level: j, name: coll[j]['collection_name'], pid: coll[j]['collection_id']});
	    					}
		                    return {institution: inst, path: curCollPath}
		                })   				
    				}
	            }
    	} else {
	        let parsedCollectionData= this.collectionDiscoveryService.getDataFromCollectionRecord(this.item);
	        if (parsedCollectionData){
	            let collectionPathsPromises= parsedCollectionData.map((collectionData)=>{
	                return this.collectionDiscoveryService.getSubColWithPath(collectionData['collectionId'], collectionData['institution']);
	            });
	            this.$q.all(collectionPathsPromises).then((collectionPaths)=>{
	                collectionPaths = collectionPaths.filter((cPath)=>{ return cPath != undefined});
	                
				    let unique_array = [];
				    //remove duplicates
				    for(let i = 0;i < collectionPaths.length; i++){
				        if(!unique_array.some((element, index, array)=>{return collectionPaths[i].value.pid.value === element.value.pid.value;})){
				            unique_array.push(collectionPaths[i])
				        }
				    }
				    collectionPaths=unique_array;
	                this.paths= collectionPaths.map((collectionPath, index)=>{
	                    return {institution: parsedCollectionData[index]['institution'],
	                        path: collectionPath.path.concat({level: collectionPath.level, name: collectionPath.value.name || collectionPath.value.title, pid: collectionPath.value.pid.value})}
	                })
	            });
	        }
        }
    }

    closeDialog(){
        this.$mdDialog.hide();
    }
    
    get isAlmaDisplay() {
    	return this.almaDisplay != undefined && this.almaDisplay == true;    
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/collectionDiscovery/recordCollectionPaths/recordCollectionPaths.directive.ts